module.exports = __webpack_public_path__ + "static/media/Traffic Cop.b089352b.jpg";